import classNames from 'classnames';
import { throttle } from '@whitesharx/starfall-frontend-ui-kit';
import React, { FC, ReactNode, useEffect, useState } from 'react';
import Modal, { ModalProps } from '../../Modal';

import ModalHeader, { MODAL_HEADER_ID } from '../ModalHeader/ModalHeader';
import { containerStyles, modalContentStyles } from './styles.css';

export type ChessModalProps = ModalProps & {
  onRequestClose?: () => void;
  header?: ReactNode;
  children: ReactNode;
  containerClassName?: string;
  maxWidth?: number;
  contentClassName?: string;
};

const Chess: FC<ChessModalProps> = ({ header, maxWidth, contentClassName, containerClassName, children, ...props }) => {
  const [maxHeight, setMaxHeight] = useState<string>('100%');

  const onResize = () => {
    if (props.fullWindow) {
      const headerHeight = document.getElementById(MODAL_HEADER_ID)?.clientHeight || 0;
      setMaxHeight(`calc(100% - ${headerHeight}px)`);
    }
  };

  useEffect(() => {
    const throttledEffect = throttle(onResize, 50);

    throttledEffect();

    const view = window.visualViewport || window;

    view.addEventListener('resize', throttledEffect);

    return () => {
      view.removeEventListener('resize', throttledEffect);
    };
  }, [onResize]);

  return (
    <Modal.Adaptive {...props} maxWidth={maxWidth}>
      <div className={classNames(containerStyles, containerClassName)}>
        {header && <ModalHeader onRequestClose={props.onRequestClose}>{header}</ModalHeader>}
        <div className={classNames(modalContentStyles, contentClassName)} style={{ maxHeight }}>
          {children}
        </div>
      </div>
    </Modal.Adaptive>
  );
};

export default Chess;
